import(/* webpackMode: "eager" */ "D:\\Klienti - D\\WHO bg\\www - AI\\src\\app\\cargo-insurance\\page.tsx");
